import { render, staticRenderFns } from "./supplyManagement.vue?vue&type=template&id=053d2f26"
import script from "./supplyManagement.vue?vue&type=script&lang=js"
export * from "./supplyManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports